import shortUUID from 'short-uuid';

if (Drupal.api == null) {
  Drupal.api = {};
}

Drupal.api.cartclient = (idfSuffix) => {
  return {
    cart: {},
    errorMsg: '',
    idf: null,
    idfSuffix: idfSuffix || '',
    csrfToken: null,
    articleNr: null,
    cartIsLoaded: false,
    cartIsLoading: false,
    isLoaded: false,
    thirdPartyCookies: {
      // statistics cookies - other possible values: matomo, google_tagmanager
      statistics: ['econda'],
      // marketing cookies - other possible values: facebook_pixel
      marketing: ['facebook_pixel', 'google_tagmanager'],
    },

    getCookieValue(name) {
      const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return cookieValue ? cookieValue.pop() : '';
    },
    getCookieAccept() {
      let cookieAccept = '';

      if (this.getCookieValue('cookiebot-consent--statistics') === '1') {
        cookieAccept += this.thirdPartyCookies.statistics.join(',');
      }
      if (this.getCookieValue('cookiebot-consent--marketing') === '1') {
        cookieAccept += (cookieAccept !== '' ? ',' : '') + this.thirdPartyCookies.marketing.join(',');
      }

      return cookieAccept;
    },

    getWestermannLink(digitalCartUrl, returnUrl) {
      let url = digitalCartUrl;
      url += url.includes('?') ? '&' : '?';
      const searchParams = new URLSearchParams(window.location.search);
      url += `return_url=${encodeURIComponent(returnUrl)}&cookie_accept=${this.getCookieAccept()}&${this.getEmosParams()}&akz=${searchParams.get('bc2')}`;

      return url;
    },
    getPaymentUrl(payment, articleNr, redirectUrl) {
      return `https://mein.westermann.de/buy?zahlweg=${payment}&p_id=${articleNr}&return_url=${redirectUrl}&cookie_accept=${this.getCookieAccept()}&${this.getEmosParams()}`;
    },
    getEmosParams() {
      if (emos3.emos_sid) {
        let s = 'emos_sid=' + encodeURIComponent(emos3.emos_sid);
        if (emos3.emos_vid) {
          s += '&emos_vid=' + encodeURIComponent(emos3.emos_vid);
        }
        return s;
      } else {
        return '';
      }
    },
    getCartUrl() {
      gtag_report_conversion_checkout();
      return `https://mein.westermann.de/ext/de/lernando/pos?quelle=warenkorb&idf=${
        this.idf
      }&cookie_accept=${this.getCookieAccept()}&${this.getEmosParams()}`;
    },
    getCartUrlEvent() {
      gtag_report_conversion_checkout();
      return this.getCartUrl();
    },
    getPaypalUrl(idfOverride) {
      var idf = this.idf;
      if (idfOverride) {
        idf = idfOverride;
      }
      return `https://mein.westermann.de/ext/de/lernando/pos?anon=1&zahlweg=paypal&quelle=warenkorb&idf=${
        idf
      }&cookie_accept=${this.getCookieAccept()}&${this.getEmosParams()}`;
    },
    directlyToPaypal(articleNrs, variant, trackingType) {
      var idf = shortUUID.generate() + '-temp';
      var cartUrl = this.getPaypalUrl(idf);
      this.addToCart(articleNrs, variant, trackingType, idf).then(function () {
        setTimeout(() => {
          window.location.href = cartUrl;
        }, 1000);
      });
    },
    getToken() {
      return fetch('/session/token')
        .then((response) => {
          return response.text();
        })
        .then((token) => {
          this.csrfToken = token;
        });
    },

    isEmpty() {
      return this.cart.positionen == null || this.cart.positionen.length === 0;
    },
    getIdf() {
      this.idf = window.localStorage.getItem('idf' + this.idfSuffix);

      return this.idf;
    },

    getIsLoaded() {
      return this.isLoaded;
    },

    generateLocalStorageIdf() {
      window.localStorage.setItem('idf' + this.idfSuffix, shortUUID.generate());
    },
    goBack() {
      var referer = document.referrer;
      if (referer.includes('intermediate-cart')) {
        referer = '/';
      }
      location.href = referer;
    },
    fetchCart(force, callback) {
      if (force === true || this.cartIsLoaded === false) {
        if (this.getIdf() != null) {
          this.getToken().then(() => {
            fetch(`/api/cart/?idf=${this.getIdf()}`, {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-CSRF-TOKEN': this.csrfToken,
              },
            }).then((response) => {
              return response.json().then((cart) => {
                this.cart = cart.data;
                this.cartIsLoaded = true;
                this.cart.positionen.sort((a, b) => (b.id > a.id ? 1 : a.id > b.id ? -1 : 0));
                if (callback) {
                  callback(this.cart);
                }
                this.isLoaded = true;
              });
            });
          });
        } else {
          this.isLoaded = true;
          this.cart = {};
        }
      } else {
        this.isLoaded = true;
        this.cart = {};
      }
    },
    addCartItems(items, variant, trackingType, idfOverride, var2Override, redirect) {
      if (this.getIdf() == null) {
        this.generateLocalStorageIdf();
      }

      var idf = this.getIdf();

      if (idfOverride) {
        idf = idfOverride;
      }

      gtag_report_conversion_add_to_cart();
      const searchParams = new URLSearchParams(window.location.search);
      this.getToken().then(() => {
        fetch(`/api/cart/create?idf=${idf}&artikel=${JSON.stringify(items)}&kampagneId=${searchParams.get('bc2')}&kampagneDatum=${searchParams.get('bc1')}&econda_var1=${variant}&econda_var2=${var2Override}`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': this.csrfToken,
          },
        }).then((response) => {
          this.errorMsg = '';
          response.json().then((data) => {
            if (data.errors) {
              this.errorMsg = 'Die ISBN(s) ' + data.errors.join(',') + ' ist/sind ungültig oder nicht bei lernando.de erhältlich. ';
            }
          });

          this.fetchCart(true);
          if (redirect) {
            location.href = '/warenkorb';
          }
          return true;

        });
      });
    },

    async addToCart(articleNrs, variant, trackingType, tempCart, var2Override, disableRedirect) {
      if (this.getIdf() == null) {
        this.generateLocalStorageIdf();
      }
      const isbns = Array.isArray(articleNrs) ? articleNrs : [articleNrs];
      const items = [];
      isbns.forEach((isbn) => {
        items.push({
          isbn: isbn.trim(),
          pid: isbn.trim(),
          menge: 1,
        });
      });
      this.addCartItems(items, variant, trackingType, tempCart, var2Override);

      if (!disableRedirect) {
        setTimeout(function () {
          if (window.lernandoSite && window.lernandoSite == 'lernando') {
            location.href = '/intermediate-cart?product=' + isbns[0];
          } else {
            location.href = '/warenkorb';
          }

        }, 1000);
      }

    },
    track(isbn) {
      var that = this;
      this.fetchCart(true, function () {

        that.cart.positionen.forEach((item) => {
          if (item.isbn == isbn) {
            var emospro = {};
            emospro.content = 'checkout/cart';
            const econdaItems = [];
            var econda_data = {
              type: 'c_add',
              sku: item.isbn,
              pid: item.isbn,
              name: item.titel,
              price: item.einzelpreis,
              count: 1,

            };

            econdaItems.push(econda_data);
            emospro.ec_Event = econdaItems;
            window.emos3.send(emospro);
          }
        });
      });

    },

    removeItemsFromCart(items) {
      const itemsIsbns = [];
      items.forEach((item) => {
        itemsIsbns.push(item.isbn);
      });
      this.getToken().then(() => {
        fetch(`/api/cart/?idf=${this.getIdf()}&artikelNrs=${itemsIsbns.join(',')}`, {
          method: 'DELETE',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': this.csrfToken,
          },
        }).then(() => {
          this.fetchCart(true);
        });
      });
    },

    removeFromCart(articleNr) {
      this.removeItemsFromCart([{ isbn: articleNr }]);
    },

    changeQuantity(articleNr, menge) {
      fetch(`/api/cart/?idf=${this.getIdf()}&artikelNr=${articleNr}&menge=${menge}`, {
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': this.csrfToken,
        },
      }).then(() => {
        this.fetchCart(true);
      });
    },

    getPriceByProduct(priceStr, quantityStr) {
      const price = Number(priceStr.replace(',', '.'));
      const quantity = Number(quantityStr);
      const priceByProduct = price * quantity;
      const roundedPrice = priceByProduct.toFixed(2).replace('.', ',') + ' €';

      return roundedPrice;
    },
  };
};
